import { Button, ButtonsGroup, Flex, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../../../enums/modalId'
import { useMissingCustomerDetailsForm } from '../../contexts/missingCustomerDetailsFormContext'

export const MissingCustomerDetailsModalFooter = (): ReactElement => {
  const { t } = useTranslation()
  const { isLoading, isSubmitting, submitForm, validate } = useMissingCustomerDetailsForm()
  const { close: closeMissingComplianceDetailsModal } = useModal(ModalId.InvoiceEditorMissingComplianceDetailsModal)

  const isFooterActionButtonDisabled = isLoading || isSubmitting

  const handleCancelButtonClick = useCallback(() => {
    closeMissingComplianceDetailsModal()
  }, [closeMissingComplianceDetailsModal])

  const handleSaveAndContinueButtonClick = useCallback(async () => {
    const isFormValid = await validate()

    if (isFormValid) {
      submitForm()
    }
  }, [submitForm, validate])

  return (
    <Flex justifyContent="flex-end" alignItems="center" flexGrow={1}>
      <ButtonsGroup>
        <Button disabled={isFooterActionButtonDisabled} onClick={handleCancelButtonClick} variant="text">
          {t('external_invoices.send_as_e_invoice.modal.buttons.cancel')}
        </Button>
        <Button
          disabled={isFooterActionButtonDisabled}
          loading={isSubmitting}
          onClick={handleSaveAndContinueButtonClick}
        >
          {t('external_invoices.send_as_e_invoice.modal.buttons.save_and_continue')}
        </Button>
      </ButtonsGroup>
    </Flex>
  )
}
